import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'

export const TextContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 7.5rem;
  right: 0;
  left: 0;
  display: flex;
  align-items: end;
  justify-content: center;
  z-index: 1;

  @media screen and (min-width: 768px) {
    align-items: end;
    bottom: 9rem;
  }
`

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.serif.fontFamily};
  font-size: 60px;
  line-height: 95%;
  letter-spacing: -2px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 37.7rem;
  padding-top: 6rem;

  @media screen and (min-width: 1200px) {
    padding-top: 16rem;
  }
`

export const TopImage = styled(ResponsiveImage)`
  width: 100%;
`

export const CurvedTextWrapper = styled.svg`
  width: 100%;
  max-width: 20rem;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-family: ${({ theme }) => theme.fonts.brand};
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;

  text {
    fill: currentColor;
  }

  path {
    fill: transparent;
    stroke: transparent;
  }
`

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 30rem;
  margin-top: 3rem;
`
